'use client';

import { isString } from 'lodash';
import { useParams } from 'next/navigation';

export const useURLBoardId = (): string | undefined => {
  const params = useParams();

  if (!params) {
    return undefined;
  }
  const value = params.boardId;

  return isString(value) ? value : undefined;
};
